import React, { useEffect, useState } from 'react';
import { Paper, Box, List, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useAuth } from "../../../hooks/useAuth";//hooks/useAuth
import {
  selectPublicMenus,
  selectProtectedMenus
} from '../../../store/slices/database/menuConfigSlice';//store/slices/database/menuConfigSlice
import {
  fetchPublicMenuThunk
} from '../../../store/thunks/mdsThunks';
import {
  setPublicMenuData
} from '../../../store/slices/database/menuConfigSlice';

// Import templates
import { getTemplate, getTemplatePosition } from './templates';
import MobileDrawer from './MobileDrawer';

import { logger } from "helpers/logger";

const Navbar = ({ template = 'default', isMobile = false, mobileOpen = false, onMobileClose, anchor = 'left' }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const keycloakAuth = useAuth();

  const publicMenus = useSelector(selectPublicMenus);
  const protectedMenus = useSelector(selectProtectedMenus);

  const menus = [
    ...(publicMenus || []),
    ...(keycloakAuth.isAuthenticated ? (protectedMenus || []) : [])
  ];

  useEffect(() => {
    const fetchMenus = async () => {
      if (!publicMenus || publicMenus.length === 0) {
        try {
          logger.info('🔧 Fetching fresh domain data from database...');
          const publicMenu = await dispatch(fetchPublicMenuThunk()).unwrap();
          logger.info('✅ Public Menus Are:', publicMenu?.data);

          dispatch(setPublicMenuData(publicMenu));
        } catch (error) {
          logger.error('Failed to fetch menus:', error);
        }
      }
    };

    fetchMenus();
  }, [dispatch, publicMenus]);

  const handleItemClick = (item) => {
    if (item.to) {
      navigate(item.to);
      if (isMobile && onMobileClose) {
        onMobileClose();
      }
    }
  };

  if (isMobile) {
    return (
      <MobileDrawer
        open={mobileOpen}
        onClose={onMobileClose}
        anchor={anchor}
        items={menus?.filter(item => !item.parentId && item.active)}
        flatNavigationItems={menus?.filter(item => item.active)}
        onItemClick={handleItemClick}
      />
    );
  }

  // Get the template component dynamically
  const TemplateComponent = getTemplate(template);

  return (
    <TemplateComponent
      items={menus?.filter(item => !item.parentId && item.active)}
      onItemClick={handleItemClick}
      flatNavigationItems={menus?.filter(item => item.active)}
    />
  );
};

// Export helper function to get position
export const getNavbarPosition = (template) => {
  return getTemplatePosition(template);
};

export default Navbar;
